import { render } from "./CategoryDropdown.vue?vue&type=template&id=74289f4d&scoped=true&ts=true"
import script from "./CategoryDropdown.vue?vue&type=script&lang=ts"
export * from "./CategoryDropdown.vue?vue&type=script&lang=ts"

import "./CategoryDropdown.vue?vue&type=style&index=0&id=74289f4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74289f4d"]])

export default __exports__